import React, { useMemo } from "react"
import tw from "twin.macro"
import Image from "next/image"
import { EmbedCardProps } from "./fullWidth"
import Link from "next/link"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

export default function EmbedMedium(props: EmbedCardProps) {
  const { url, body } = props

  const bodyJson = body.json
  const bodyText = useMemo(() => {
    return documentToReactComponents(bodyJson)
  }, [body])

  const imageUrl = props.image.url
  const imageTitle = props.image.title
  const imageWidth = props.image.width
  const imageHeight = props.image.height
  const placeholderImgUrl = imageUrl + "?w=25&h=25"

  const altText = imageTitle
    ? `${imageTitle} – The Richard Pousette-Dart Foundation`
    : `The Richard Pousette-Dart Foundation`

  const card = (
    <div tw="py-0 mx-auto flex flex-col max-w-screen-card-lg tablet:(max-w-screen-mobile) desktop:(max-w-screen-mobile-lg)">
      <Image
        src={imageUrl}
        height={imageHeight}
        width={imageWidth}
        alt={altText}
        placeholder="blur"
        blurDataURL={placeholderImgUrl}
      />
      {bodyText && (
        <div className="caption" tw="!px-2 tablet:(!px-4)">
          {bodyText}
        </div>
      )}
    </div>
  )

  if (!url) {
    return <div tw="py-8 pb-10 tablet:(py-16 pb-20)">{card}</div>
  }
  return (
    <Link className="embedLarge" href={url}>
      {card}
    </Link>
  )
}
